/**
 * If your app has sensitive data like a password or credit card input, you can
 * add the class _lr-hide to any DOM nodes to prevent that data from ever
 * leaving the browser.
 *
 * Ref: https://blog.logrocket.com/redux-logging-in-production-3b2a4816b713/
 */
export const logRocketHideClassName = '_lr-hide';
